import React from "react";

export default function FILTVLiveTicker() {
    return (
        <div className="bg-red-600 overflow-hidden">
            <div className="py-1 marquee">
                <span>
                    🔥 Today's Deals • Flat 40% OFF • COD Available • Watch 5 Minutes &amp; Earn
                    Streak Points • Powered by Think5Whys • Support Local Businesses •
                    FindItLocal TV • Shop Smart •
                </span>
            </div>
        </div>
    );
}
